export default __webpack_public_path__ + "static/media/warning--roadworks--g3.2add7320.png";